import { createLazyReactDirective } from '../shell/createLazyReactDirective';

createLazyReactDirective(
  async () => (await import('./SvgMarkupEditorButton')).SvgMarkupEditorButton,
  'svgMarkupEditorButton',
  {
    sectionId: '=',
    imageUrl: '=',
    svgUrl: '=',
    boundFloors: '=',
    onSaved: '&',
  },
);
